import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { SimpleField } from "../../components/fields/simpleField.jsx";
import { useInternet } from "../../hooks/useInternet.js";
import { useNotify } from "../../hooks/useNotify.js";
import { HOST } from "../../hooks/constants.js";
import { SubmitButton } from "../../components/fields/submitButton.jsx";

export function SignupPage() {
  let navigate = useNavigate();
  let [search, setSearch] = useSearchParams();
  let internet = useInternet();
  let { control, handleSubmit, formState, reset } = useForm({
    resolver: zodResolver(
      zod
        .object({
          email: zod.string(),
          password: zod.string(),
          passwordConfirm: zod.string(),
        })
        .superRefine((data, ctx) => {
          if (data.password !== data.passwordConfirm)
            ctx.addIssue({
              path: ["passwordConfirm"],
              code: "custom",
              message: "Password must match",
            });
        })
    ),
  });
  let notify = useNotify();
  let signup = (data) => {
    let invitation = search.get("invitation");
    return internet
      .post("/auth/signup", { ...data, invitation })
      .then(async (res) => {
        reset({}, { keepValues: true });
        let { token } = await res.json();
        window.localStorage.token = token;
        navigate("/transactions");
      })
      .catch((e) => {
        notify({ message: "unable to signup", type: "danger" });
      });
  };
  let signupOauth = (e) => {
    e.preventDefault();
    window.location.href = `${HOST}/auth/google?language=${
      i18n.language
    }&invitation=${search.get("invitation")}`;
  };
  return (
    <>
      <div className={"flex items-center"}>
        <h1 className={"font-bold display text-xl flex-grow"}>Sign up</h1>
        <Link
          to={"/auth/login?" + search.toString()}
          className={"hover:underline"}
        >
          Log in instead
        </Link>
      </div>

      <p>You don't have an account? Create it by filling the form below.</p>

      {search.get("invitation") && (
        <div className={"bg-orange-200 rounded p-3"}>
          You have been invited to join a team in Lancerkit. Filling the form
          below will make you join your team. If you don't want to do this,
          <a
            href={"#"}
            onClick={(e) => {
              e.preventDefault();
              setSearch("invitation", "");
            }}
            className={"underline"}
          >
            click here
          </a>
        </div>
      )}

      <form onSubmit={handleSubmit(signup)} className={"flex flex-col gap-3"}>
        <SimpleField
          name={"email"}
          label={"email"}
          type={"email"}
          control={control}
        />
        <SimpleField
          name={"password"}
          label={"password"}
          type={"password"}
          control={control}
        />
        <SimpleField
          name={"passwordConfirm"}
          label={"password_confirm"}
          type={"password"}
          control={control}
        />
        <SubmitButton formState={formState}>Sign up</SubmitButton>
      </form>

      <div className={"flex items-center gap-3"}>
        <div
          style={{
            width: "100%",
            height: "1px",
            borderTop: "1px solid rgba(0,0,0,20%)",
          }}
        ></div>
        <div>or</div>
        <div
          style={{
            width: "100%",
            height: "1px",
            borderTop: "1px solid rgba(0,0,0,20%)",
          }}
        ></div>
      </div>

      {search.get("error") == "invitation_expired" && (
        <div className={"bg-red-200 rounded p-3"}>
          Your invitation has expired. Please ask the person who invited you to
          invite you once again
        </div>
      )}

      <a
        href="src/pages"
        className="socialbutton socialbutton--google rounded"
        onClick={signupOauth}
      >
        Sign With Google
      </a>
    </>
  );
}
